import { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Label,
} from "reactstrap";

const CitySelectInput = ({ options, value, setValue, placeholder, label }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [searchTerm, setSearchTerm] = useState("");

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  const handleSelect = (city) => {
    setValue(city);
    setSearchTerm(city);
    setDropdownOpen(false);
  };

  useEffect(() => {
    setFilteredOptions(options);
    setSearchTerm("");
  }, [options]);

  useEffect(() => {
    const filterOptions = () => {
      if (searchTerm) {
        const lowercasedTerm = searchTerm.toLowerCase();
        const filtered = options.filter((option) =>
          option.toLowerCase().includes(lowercasedTerm)
        );
        setFilteredOptions(filtered);
      } else {
        setFilteredOptions(options);
      }
    };

    filterOptions();
  }, [searchTerm, options]);

  return (
    <div>
      {label && <Label className="figma-input-label">{label}</Label>}
      <Dropdown
        isOpen={dropdownOpen}
        toggle={toggleDropdown}
        className="normal-input-2"
      >
        <DropdownToggle className="normal-input br-0 f-4 full-width text-start border-none bg-transparent">
          {value?.name??value?? placeholder}
        </DropdownToggle>
        <DropdownMenu className="full-width">
          <div className=" outer-transparent-shadow">
          <Input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search for a city..."
            className="normal-input-2  bg-transparent br-0  "
          />
          </div>
          <div
            style={{
              height: "300px",
              overflowY: "scroll",
              overflowX: "hidden",
            }}
          >
            {filteredOptions.map((city, index) => (
              <DropdownItem
                tag={"div"}
                className="cursor-pointer"
                key={index}
                onClick={() => {
                  handleSelect(city);
                  toggleDropdown();
                }}
              >
                {city}
              </DropdownItem>
            ))}
            {filteredOptions?.length === 0 && (
              <DropdownItem disabled>No cities found</DropdownItem>
            )}
          </div>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default CitySelectInput;
